document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll('.ecom-child-element.ecom-collection__product-submit');

  if (buttons.length > 0) {
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        setTimeout(function() {
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }
        }, 500);
      });
    });
  }
});